module.exports = __webpack_public_path__ + "static/media/crown.b52f5d2f.svg";